@if (displaySuffix()) {
  <div class="suffix">
    <ng-content select="[tiimeSuffix]"></ng-content>
  </div>
}
@if (displayPrefix()) {
  <div class="prefix">
    <ng-content select="[tiimePrefix]"></ng-content>
  </div>
}
<ng-content></ng-content>
@if (label()) {
  <label [attr.for]="contentId()">{{ placeholder() }}</label>
}
@if (errorMessage()) {
  <span
    class="error-label"
    [tiimeTooltip]="errorMessage()"
    tooltipClass="tiime-tooltip warn"
    tooltipHideWithoutEllipsis
  >
    {{ errorMessage() }}
  </span>
}
